export default {
    methods: {
        getReportFilters(reportFilterName) {
            const filters = localStorage.getItem(reportFilterName);

            if (filters) {
                return JSON.parse(filters);
            }
        },

        setReportFilters(reportFilterName, reportFilters) {
            localStorage.setItem(reportFilterName, JSON.stringify(reportFilters));
        }
    }
}